/**
 * The one line said when Settings → Computer is on in the desktop app and
 * the model cannot work from screenshots: the Worker offers it only the
 * window-control tools (`computerUseFor`, worker/lib/engine/models.ts), so
 * an app that shares no controls is out of its reach. Pure, so it is tested.
 */

import { COMPUTER_TOOL_PREFIX } from '@wire';

/** Whether the desktop offers its computer-use tools right now. */
export const offersComputer = (tools: ReadonlyArray<{ name: string }> | undefined): boolean =>
  !!tools?.some((t) => t.name.startsWith(COMPUTER_TOOL_PREFIX));

export function computerNotice(
  model: { short: string; tools?: boolean; computerUse?: boolean } | undefined,
  computerOn: boolean
): string | null {
  if (!computerOn || !model?.tools || model.computerUse) return null;
  return `${model.short} cannot see the screen, so it works only from window controls.`;
}

/** In a PC's Dispatch thread, a model offered no tools cannot reach the PC
 *  at all (the Worker offers its published tools only to `tools` models). */
export function pcNotice(model: { short: string; tools?: boolean } | undefined, pcName: string | undefined): string | null {
  if (!pcName || !model || model.tools) return null;
  return `${model.short} can't use ${pcName}.`;
}
